import { useTranslation } from 'react-i18next';

export const useTranslated = (translationKey = '', options = {}) => {
  const { t } = useTranslation();
  return translationKey ? t(translationKey, options) : null;
};
